<p-blockUI [target]="permissionEmailDialog" [blocked]="updating">
	<p-progressSpinner ariaLabel="loading"></p-progressSpinner>
</p-blockUI>

<app-blockable-div #permissionEmailDialog>
	<div class="layout-content">
		<form (ngSubmit)="submit()" [formGroup]="customEmailForm">
			<div class="grid">
				<div class="col-12">
					<div class="flex justify-content-between flex-wrap" [ngClass]="showErrorsNoValid('borderRow')">
						<div class="flex align-items-center justify-content-center" [ngClass]="showErrorsNoValid('label')">{{
							'COVER_SITE' | translate }}</div>
						<div class="flex align-items-center justify-content-center"
							[ngClass]="showErrorsNoValid('borderInput')">
							<p-fileUpload *ngIf="!canDeleteUpload" mode="basic" chooseLabel="{{'UPLOAD_IMAGE' | translate }}"
								type="file" (onSelect)="handleFileInput($event)" [ngClass]="dynamicLongInputTextWidth()"
								[styleClass]="dynamicLongInputTextWidth()">
							</p-fileUpload>
							<img *ngIf="canDeleteUpload" id="previewImage" [src]="imgPreview" class="border-radius-xl mr-2" />
							<div *ngIf="canDeleteUpload && imgPreview === ''" class="mr-2 text-50">
								<p>{{ 'RELOAD_IMAGE' | translate }}</p>
							</div>
							<button *ngIf="canDeleteUpload" pButton pRipple type="button"
								id="custom-email-permission-upload-cancel" icon="pi cm-cancel" class="p-button-danger"
								size="small" (click)="clearLogo()">
							</button>
						</div>
					</div>
				</div>
				<div *ngIf="!canDeleteUpload" class="col-12 flex flex-column justify-content-start w-full pt-0 mb-2">
					<p>{{ ('MAX_UPLOAD_SIZE' | translate) + ' : ' + (maxUploadSize / 1024).toFixed() + ' KB' }}</p>
					<p>{{ 'CUSTOMIZE_EMAIL_IMAGE_INFO_NEW' | translate }}</p>
				</div>
				<div *ngIf="canDeleteUpload && imgPreview !== ''"
					class="col-12 flex flex-column justify-content-start w-full pt-0 mb-2">
					<p>{{ ('IMAGE_PREVIEW_INFO' | translate) + '80 px' }}</p>
				</div>
				<div [ngClass]="col12Responsive()">
					<div class="flex justify-content-between flex-wrap border-bottom-1 border-100"
						[ngClass]="dynamicInputTextFormat('borderRow')">
						<div class="flex align-items-center justify-content-center"
							[ngClass]="dynamicInputTextFormat('label')">{{ 'FACILITY_NAME' | translate }}</div>
						<div class="flex align-items-center justify-content-center"
							[ngClass]="dynamicInputTextFormat('borderInput')">
							<input type="text" pInputText [ngClass]="dynamicInputTextWidth()"
								id="custom-email-permission-inputName" formControlName="Name"
								placeholder="{{ 'FACILITY_NAME' | translate }}" maxlength="26" />
						</div>
					</div>
				</div>
				<div [ngClass]="col12Responsive()">
					<div class="flex justify-content-between flex-wrap border-bottom-1 border-100"
						[ngClass]="dynamicInputTextFormat('borderRow')">
						<div class="flex align-items-center justify-content-center"
							[ngClass]="dynamicInputTextFormat('label')">{{ 'PHONE' | translate }}</div>
						<div class="flex align-items-center justify-content-center"
							[ngClass]="dynamicInputTextFormat('borderInput')">
							<input type="text" pInputText [ngClass]="dynamicInputTextWidth()"
								id="custom-email-permission-inputPhone" formControlName="Phone"
								placeholder="{{ 'PHONE' | translate }}" maxlength="26" />
						</div>
					</div>
				</div>
				<div [ngClass]="col12Responsive()">
					<div class="flex justify-content-between flex-wrap border-bottom-1 border-100"
						[ngClass]="dynamicInputTextFormat('borderRow')">
						<div class="flex align-items-center justify-content-center"
							[ngClass]="dynamicInputTextFormat('label')">{{ 'EMAIL' | translate }}</div>
						<div class="flex align-items-center justify-content-center"
							[ngClass]="dynamicInputTextFormat('borderInput')">
							<input type="text" pInputText [ngClass]="dynamicInputTextWidth()"
								id="custom-email-permission-inputEmail" formControlName="Email"
								placeholder="{{ 'EMAIL' | translate }}" maxlength="100" />
						</div>
					</div>
				</div>
				<div [ngClass]="col12Responsive()">
					<div class="flex justify-content-between flex-wrap border-bottom-1 border-100"
						[ngClass]="dynamicInputTextFormat('borderRow')">
						<div class="flex align-items-center justify-content-center"
							[ngClass]="dynamicInputTextFormat('label')">{{ 'WEBSITE' | translate }}</div>
						<div class="flex align-items-center justify-content-center"
							[ngClass]="dynamicInputTextFormat('borderInput')">
							<input type="text" pInputText [ngClass]="dynamicInputTextWidth()"
								id="custom-email-permission-inputWebsite" formControlName="Website"
								placeholder="{{ 'WEBSITE' | translate }}" maxlength="100" />
						</div>
					</div>
				</div>
				<div class="col-12">
					<form [formGroup]="searchControl" class="form-signin text-center">
						<div class="flex justify-content-between flex-wrap" [ngClass]="showErrorsNoValid('borderRow')">
							<div class="flex align-items-center justify-content-center" [ngClass]="showErrorsNoValid('label')">
								{{ 'SEARCH_ADDRESS' | translate }}</div>
							<div class="flex align-items-center justify-content-center"
								[ngClass]="showErrorsNoValid('borderInput')">
								<p-autoComplete formControlName="Address" [suggestions]="filteredPlace"
									[ngClass]="dynamicLongInputTextWidth()" [styleClass]="dynamicLongInputTextWidth()"
									[inputStyleClass]="dynamicLongInputTextWidth()" [panelStyleClass]="dynamicAutocomplete()"
									id="permission-dialog-input-location" (completeMethod)="completeMethod($event)"
									field="description" [dropdown]="true" (onSelect)="onSelectSuggestion($event)"
									[forceSelection]="true"
									[placeholder]="(this.currentTemplate && this.currentTemplate !== undefined && this.currentTemplate.Address && this.currentTemplate.Address !== '') ? this.currentTemplate.Address : ( 'SEARCH_ADDRESS' | translate )">
								</p-autoComplete>
							</div>
						</div>
					</form>
				</div>
				<div class="col-12 pb-2 flex" [ngClass]="justifyContentStyle()">{{ 'FACILITY_INFO' | translate }}</div>
				<div class="col-12 pt-0 flex justify-content-center w-full">
					<textarea class="w-full" id="float-input" rows="10" cols="80" pInputTextarea
						[formControlName]="'ExtraInfo'"></textarea>
				</div>
				<div class="col-12 flex flex-column justify-content-start w-full">
					<p>{{ 'NOTE' | translate }}:</p>
					<p>- {{'CUSTOMIZE_EMAIL_IMAGE_NOTE' | translate }}</p>
					<p>- {{'CUSTOMIZE_EMAIL_FIELDS_NOTE' | translate }}</p>
					<p>- {{'CUSTOMIZE_EMAIL_OPTIONAL_FIELDS_NOTE' | translate}}</p>
				</div>
			</div>

			<div class="grid mt-5 mb-1 mx-1 flex justify-content-center align-items-center">
				<button type="submit" pButton pRipple [disabled]="!customEmailForm.valid"
					label="{{ 'CONFIRM' | translate }}"
					class="p-button-primary text-xl font-normal mt-3 sm:mt-0 mr-0 sm:mr-1" [ngClass]="dynamicButtonWidth()">
				</button>
				<button type="button" pButton pRipple (click)="closeDialog()" label="{{ 'CANCEL' | translate }}"
					class="p-button-secondary text-xl font-normal mt-3 sm:mt-0 ml-0 sm:ml-1"
					[ngClass]="dynamicButtonWidth()">
				</button>
			</div>

		</form>
	</div>
</app-blockable-div>